import React from 'react';
import { Box, Divider, Button, Typography } from '@mui/material';
import { FormikProvider, FieldArray } from 'formik';
import EstimateMultiFileForm from '../../../components/chancemng/estimate/EstimateMultiFileForm';
import EstimateForm from '../../../components/chancemng/estimate/EstimateForm';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const EstimateFormContainer = ({
  formik,
  estimate,
  chance,
  type,
  handleClose,
}) => {
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Box>
        {type === 'add' && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              py: 2,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Button type="submit" color="primary" variant="contained">
              세부사항 저장
            </Button>
          </Box>
        )}
        {type === 'edit' && estimate?.useYn === 'Y' && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              py: 2,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Button type="submit" color="primary" variant="contained">
              세부사항 저장
            </Button>
          </Box>
        )}
      </Box>

      <EstimateForm chance={chance} estimate={estimate} formik={formik} />

      <Divider sx={{ my: 1 }} />
      <Box
        sx={{
          px: 1,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Box sx={{ mr: 1 }}>
          <FileUploadIcon />
        </Box>
        <Typography variant="subtitle2">매입견적서 업로드</Typography>
      </Box>
      <FormikProvider value={formik}>
        <FieldArray
          name="files"
          render={(arrayHelpers) => (
            <Box>
              <Box sx={{ my: 1 }}>
                {formik.values.files.map((f, index) => {
                  return (
                    <EstimateMultiFileForm
                      key={index}
                      file={f}
                      index={index}
                      touched={formik.touched}
                      errors={formik.errors}
                      handleChange={formik.handleChange}
                      handleBlur={formik.handleBlur}
                      handleRemove={() => arrayHelpers.remove(index)}
                    />
                  );
                })}
              </Box>
              <Box>
                {type === 'add' && (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      py: 2,
                      borderTop: (theme) =>
                        `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <Button type="submit" color="primary" variant="contained">
                      세부사항 저장
                    </Button>

                    <Button
                      sx={{ mx: 2 }}
                      color="secondary"
                      variant="outlined"
                      onClick={() =>
                        arrayHelpers.push({ fileDesc: '', file: null })
                      }
                    >
                      파일 추가
                    </Button>
                  </Box>
                )}
                {type === 'edit' && estimate?.useYn === 'Y' && (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      py: 2,
                      borderTop: (theme) =>
                        `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <Button type="submit" color="primary" variant="contained">
                      세부사항 저장
                    </Button>

                    <Button
                      sx={{ mx: 2 }}
                      color="secondary"
                      variant="outlined"
                      onClick={() =>
                        arrayHelpers.push({ fileDesc: '', file: null })
                      }
                    >
                      파일 추가
                    </Button>
                  </Box>
                )}
              </Box>
            </Box>
          )}
        ></FieldArray>
      </FormikProvider>
    </Box>
  );
};

export default EstimateFormContainer;
